import React from 'react';

const ThemedButton = ({
  children,
  onClick,
  primaryColor = 'blue-600',
  themeMode = 'light',
  variant = 'primary', // 'primary' | 'secondary' | 'destructive'
  size = 'medium', // 'small', 'medium', 'large'
  className = '',
  type = 'button',
  disabled = false,
  ...props
}) => {
  const themedStyles = {
    primaryButton: {
      backgroundColor: 'var(--theme-primary)',
      color: 'var(--theme-primary-contrast)',
      border: '1px solid var(--theme-primary)',
    },
    secondaryButton: {
      border: '1px solid var(--theme-primary)',
      color: 'var(--theme-secondary-text)',
      backgroundColor: 'var(--theme-secondary-bg)',
    },
    destructiveButton: {
      // Use the signal-red-500 hex directly so the destructive variant remains
      // unambiguous regardless of provider primaryColor.
      backgroundColor: '#C0563D',
      color: '#FFFFFF',
      border: '1px solid #C0563D',
    },
  };

  const getVariantStyle = () => {
    if (variant === 'secondary') return themedStyles.secondaryButton;
    if (variant === 'destructive') return themedStyles.destructiveButton;
    return themedStyles.primaryButton;
  };

  // Get size classes
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'px-3 py-1.5 text-xs';
      case 'large':
        return 'px-6 py-3 text-base';
      case 'medium':
      default:
        return 'px-4 py-2 text-sm';
    }
  };

  const baseClasses = `
    rounded-pill
    font-medium
    tracking-[-0.005em]
    focus:outline-none
    focus-themed
    transition-[background-color,transform,opacity] duration-150
    hover:opacity-90
    ${!disabled ? 'active:scale-[0.98]' : ''}
    ${getSizeClasses()}
    ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <button
      onClick={disabled ? undefined : onClick}
      type={type}
      className={baseClasses}
      style={getVariantStyle()}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default ThemedButton;